const key = (userId: string) => `eh.nameHandled:${userId}`;

export function isNameHandled(userId: string): boolean {
  try {
    return localStorage.getItem(key(userId)) === '1';
  } catch {
    return false;
  }
}

export function markNameHandled(userId: string): void {
  try {
    localStorage.setItem(key(userId), '1');
  } catch {
    /* ignore */
  }
}
